module.exports = __webpack_public_path__ + "static/page4-db1ad69e9d92cec258e22d88e987f869.png";